<template>
  <div class="logout-wrapper">
    <div class="logout-container">
      <div class="logout-card text-center">
        <div class="card-header border-0 mb-3">
          <div class="logout-icon-wrapper mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" class="bi bi-box-arrow-right logout-icon" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"/>
              <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
            </svg>
          </div>
          <h2 class="auth-title">Signed Out</h2>
          <p class="auth-subtitle">You have successfully logged out of your session.</p>
        </div>

        <div class="logout-body">
          <p class="redirect-info">
            Redirecting to sign in page in <strong>{{ countdown }}</strong> seconds...
          </p>
          
          <div class="d-flex flex-column gap-2 mt-4">
            <button @click="goToLogin" class="btn-submit">
              Sign In Again
            </button>
            <button @click="goToHome" class="btn-secondary-link">
              Return to Home Page
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LogoutPage',
  data() {
    return {
      countdown: 3,
      timer: null as any
    }
  },
  mounted() {
    // Hide standard footer
    const footer = document.querySelector(".thisfooter");
    if (footer) {
      footer.classList.add("d-none");
    }

    // Perform Logout Action
    localStorage.removeItem('user');
    localStorage.removeItem('token');

    // Start auto-redirect countdown
    this.timer = setInterval(() => {
      this.countdown -= 1;
      if (this.countdown <= 0) {
        clearInterval(this.timer);
        this.goToLogin();
      }
    }, 1000);
  },
  unmounted() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    const footer = document.querySelector(".thisfooter");
    if (footer) {
      footer.classList.remove("d-none");
    }
  },
  methods: {
    goToLogin() {
      if (this.timer) clearInterval(this.timer);
      this.$router.push('/login');
    },
    goToHome() {
      if (this.timer) clearInterval(this.timer);
      this.$router.push('/');
    }
  }
})
</script>

<style scoped>
.logout-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  padding: 20px;
}

.logout-container {
  width: 100%;
  max-width: 440px;
}

.logout-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 40px 30px;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
  color: #ffffff;
}

.logout-icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(0, 210, 255, 0.1);
  border: 1px solid rgba(0, 210, 255, 0.2);
}

.logout-icon {
  color: #00e5ff;
}

.auth-title {
  font-size: 26px;
  font-weight: 700;
  margin-top: 10px;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

.auth-subtitle {
  font-size: 14px;
  color: #b0bec5;
  margin-bottom: 20px;
}

.redirect-info {
  font-size: 14px;
  color: #eceff1;
  background: rgba(255, 255, 255, 0.08);
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.btn-submit {
  width: 100%;
  background: linear-gradient(90deg, #00d2ff 0%, #0066ff 100%);
  border: none;
  border-radius: 8px;
  padding: 14px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 102, 255, 0.4);
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 102, 255, 0.6);
}

.btn-secondary-link {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 12px;
  color: #b0bec5;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-secondary-link:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}
</style>
